import { RxJsonSchema, toTypedRxJsonSchema, ExtractDocumentTypeFromTypedRxJsonSchema } from 'rxdb';

export const F_TARIFSELECT_SCHEMA_LITERAL = {
    title: 'Schéma TarifSelect',
    description: 'TarifSelect',
    version: 0,
    keyCompression: false,
    primaryKey: { key : 'CBMARQ_STR', fields : ['CBMARQ'], separator : '' },
    type: 'object',
    properties: {
        CBMARQ_STR: { type: 'string', maxLength : 10 },
        CBMARQ: { type: 'number' },
        TF_NO: { type: 'number' },
        TF_INTITULE: { type: ['string', 'null'] },
        TS_INTERES: { type: 'number' },
        TS_INTERESLIB: { type: ['string', 'null'] },
        TS_REF: { type: ['string', 'null'] },
        TS_REFLIB: { type: ['string', 'null'] }
    },
    required: ['TF_NO']
} as const;

const schemaTyped = toTypedRxJsonSchema(F_TARIFSELECT_SCHEMA_LITERAL);
export type RxFTarifSelectDocumentType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const F_TARIFSELECT_SCHEMA: RxJsonSchema<RxFTarifSelectDocumentType> = F_TARIFSELECT_SCHEMA_LITERAL;
